import { Button, IconButton, Typography } from '@material-ui/core';
import React, { useState } from 'react';

import Backdrop from '@material-ui/core/Backdrop';
import CloseIcon from '@material-ui/icons/Close';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';

/**
 * TransitionsModal
 *
 * Modal component. Takes in passed children
 *
 * @param props
 */
const ModalContainer = (props) => {
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({
    error: false,
    hasMessage: false,
    message: '',
  });

  const {
    buttonText, buttonID, headerText, variant, color, children,
  } = props;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setResponseMessage = (message) => {
    setResponse({
      hasMessage: true,
      message,
    });
  };

  const modalContent = React.Children.map(children, (child) => React.cloneElement(child, { setOpen, setResponseMessage }));

  return (
    <div>
      <Button type='button' id={buttonID} onClick={handleOpen} variant={variant} color={color}>
        {buttonText}
      </Button>
      {response.hasMessage && (
        <Typography variant='body1' className='success'>
          {response.message}
        </Typography>
      )}
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        className='modal-wrapper'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className='modal-container'>
            <div className='modal-header'>
              <Typography variant='h2'>{headerText}</Typography>
              <IconButton className='close' aria-label='close' size='medium' onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className='modal-body'>{modalContent}</div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};
export default ModalContainer;
